enum TrackNames {
  ARView = "arView",
  Archives = "openArchive",
  CatalogDetail = "catalog_detail",
  DeepLink = "deeplink",
  FilterUsed = "filter_used",
  HomeMap = "home_map",
  ImportPE = "proposal_import_pe",
  Materials = "open_materials",
  MaterialDetail = "material_detail",
  MaterialFilter = "material_filter",
  MaterialsDownload = "materials_download",
  MaterialsPlay = "materials_play",
  NewsOpen = "new_open",
  NBAUpdate = "nba_action",
  NotificationDetails = "notifDetails",
  PointOfSales = "open_POS",
  PointOfSaleAssortment = "posAssortment",
  PointOfSaleCPV = "posCPVs",
  PointOfSaleCreation = "posCreation",
  PointOfSaleDetails = "pos_details",
  PointOfSaleKPI = "posKPI",
  PointOfSaleEdit = "posModification",
  PointOfSaleNBA = "posNBA",
  PointOfSaleOverview = "posOverview",
  PointOfSaleProposals = "posProposals",
  PointOfSaleSearch = "pos_search",
  PointOfSaleVolume = "posVolume",
  ProposalStateChange = "proposal_state",
  ProposalDetails = "proposalDetails",
  ProposalEnd = "proposal_end",
  ProposalFilter = "filterProposal",
  ProposalSearch = "searchProposal",
  ProposalStart = "proposal_start",
  ProposalDownload = "proposal_download",
  ReleaseDetails = "releaseDetails",
  TrainingOpen = "training_open",
  VisitUpdate = "updateVisit",
  VisitCreate = "newVisit",
}

export default TrackNames;
